import ReactDOM from 'react-dom';
import WatsonxCodeAssistantPE from './components/WatsonxCodeAssistantPE';
import { IntlProvider } from 'react-intl';
import normalizeWidgetInput from 'src/common/normalizeWidgetInput';
import widgetDefinition from './wxCodeAssistanatPriceEstimator.widget';
import { RenderFn } from 'src/types/widgets';
import 'carbon-components/css/carbon-components.min.css';
import { Provider } from 'react-redux';
import { store } from './lib/redux/store';
import { TranslationProvider } from '../../common/components/TranslationProvider/TranslationProvider';

const render: RenderFn = async function (instanceId, langCode, _origin, cb) {
  const { element, locale, messages } = await normalizeWidgetInput(
    instanceId,
    langCode,
    widgetDefinition,
  );
  if (!element || !locale || !messages) {
    return;
  }
  const localeCode = element.getAttribute('data-localecode') || 'en-us';

  ReactDOM.render(
    <Provider store={store}>
      <IntlProvider locale="en" defaultLocale="en">
        <TranslationProvider messages={messages}>
          <WatsonxCodeAssistantPE
            langCode={localeCode}
            test={false}
            countryToTest={'de'}
          />
        </TranslationProvider>
      </IntlProvider>
    </Provider>,
    element,
    () => cb(element),
  );
};

export default render;
